var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ID"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3C10.5045 3 9.27273 4.21949 9.27273 5.7C9.27273 6.01667 9.33995 6.3166 9.44318 6.6H3.81818C2.81545 6.6 2 7.4073 2 8.4V19.2C2 20.1927 2.81545 21 3.81818 21H20.1818C21.1845 21 22 20.1927 22 19.2V8.4C22 7.4073 21.1845 6.6 20.1818 6.6H14.5568C14.6601 6.3166 14.7273 6.01667 14.7273 5.7C14.7273 4.21949 13.4955 3 12 3ZM12 4.8C12.5128 4.8 12.9091 5.19228 12.9091 5.7C12.9091 6.20772 12.5128 6.6 12 6.6C11.4872 6.6 11.0909 6.20772 11.0909 5.7C11.0909 5.19228 11.4872 4.8 12 4.8ZM8.36364 10.2C9.39364 10.2 10.1818 10.9803 10.1818 12C10.1818 13.0197 9.39364 13.8 8.36364 13.8C7.33364 13.8 6.54545 13.0197 6.54545 12C6.54545 10.9803 7.33364 10.2 8.36364 10.2ZM14.7273 11.1H18.3636C18.8655 11.1 19.2727 11.5032 19.2727 12C19.2727 12.4968 18.8655 12.9 18.3636 12.9H14.7273C14.2255 12.9 13.8182 12.4968 13.8182 12C13.8182 11.5032 14.2255 11.1 14.7273 11.1ZM8.36364 14.7C10.35 14.7 12 15.5179 12 16.6951V16.95C12 17.1984 11.7964 17.4 11.5455 17.4H5.18182C4.93091 17.4 4.72727 17.1984 4.72727 16.95V16.6951C4.72727 15.5179 6.37727 14.7 8.36364 14.7ZM14.7273 14.7H18.3636C18.8655 14.7 19.2727 15.1032 19.2727 15.6C19.2727 16.0968 18.8655 16.5 18.3636 16.5H14.7273C14.2255 16.5 13.8182 16.0968 13.8182 15.6C13.8182 15.1032 14.2255 14.7 14.7273 14.7Z",
    fill: "currentcolor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.01a21e409fd7df2c944b288186a5f93e.svg";
export { ForwardRef as ReactComponent };